// extracted by mini-css-extract-plugin
export default {"row-layout":"styles__row-layout--HJF4q","range":"styles__range--m3gGb","row-item":"styles__row-item--2kJMx","half":"styles__half--r69Dw","description":"styles__description--afKR5"};